import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment } from '@environments/environment';

import { TranslateService } from '@ngx-translate/core';
import { FullScreenLoadingComponent } from '@shared/components/full-screen-loading/full-screen-loading.component';
import { FullScreenLoadingService } from '@shared/components/full-screen-loading/full-screen-loading.service';
import { GlobalToastComponent } from '@shared/components/global-toast/global-toast.component';
import { ToastMessageComponent } from '@shared/components/toast-message/toast-message.component';
import { ToastService } from '@shared/service/toast.service';
import { ConfirmationService } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DrawerModule } from 'primeng/drawer';
import { ToastModule } from 'primeng/toast';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    ToastModule,
    ConfirmDialogModule,
    ToastMessageComponent,
    GlobalToastComponent,
    DrawerModule,
    FullScreenLoadingComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [ConfirmationService, ToastService]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'chicilon';
  isLoading$: Observable<boolean> | undefined;
  subscription: Subscription;
  constructor(
    private fullSreenLoadingService: FullScreenLoadingService,
    private translateService: TranslateService,
    private primeng: PrimeNG,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.subscription = this.translateService.stream('primeng').subscribe(data => {
      this.primeng.setTranslation(data);
    });
  }

  ngOnInit(): void {
    this.isLoading$ = this.fullSreenLoadingService.isLoading$;
    this.setQaEnv();
  }

  private setQaEnv(): void {
    if (environment.ENV !== 'QA') {
      this.titleService.setTitle('Chicilon');
      return;
    }

    this.titleService.setTitle('TMA Solutions');

    const favicon = this.document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (favicon) {
      favicon.href = '/assets/images/tma-logo.png';
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
